import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicCaseCard from "@/components/PublicCaseCard";
import { Reveal } from "@/components/landing/Reveal";
import api from "@/lib/api";

export function FeaturedAnimals() {
  const [cases, setCases] = useState(null);

  useEffect(() => {
    api
      .get("/public/fundraisers", { params: { limit: 3 } })
      .then((res) => setCases(res.data))
      .catch(() => setCases([]));
  }, []);

  if (cases !== null && cases.length === 0) return null;

  return (
    <section className="bg-amtm-give/20 py-24 md:py-32" data-testid="landing-featured-animals">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-14 max-w-xl mx-auto">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-4">
            Right Now
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-amtm-text">Rescues that need you now.</h2>
        </Reveal>

        {cases === null ? (
          <div className="flex justify-center py-16">
            <Loader2 className="h-8 w-8 animate-spin text-amtm-teal" />
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-testid="landing-featured-animals-grid">
            {cases.map((c, i) => (
              <Reveal key={c.id} delay={i * 0.08}>
                <PublicCaseCard caseItem={c} />
              </Reveal>
            ))}
          </div>
        )}

        <div className="text-center">
          <Button
            asChild
            size="lg"
            className="rounded-full h-[52px] px-8 bg-amtm-teal text-white hover:bg-amtm-tealHover font-semibold"
            data-testid="landing-see-all-animals-button"
          >
            <Link to="/cases">See All Animals in Our Care</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
